'use client';

import { Flex, Switch, Typography } from '@coolblue-development/freddy';
import { useState } from 'react';

import { ObjectRawData } from './ObjectRawData';

export const RawData = ({ title, object }: { title: string; object: object }) => {
  const [checked, setChecked] = useState(false);

  function onSwitch() {
    setChecked(!checked);
  }

  return (
    <>
      <Flex justifyContent='space-between'>
        <Typography variant='h2' mb={300}>
          {title}
          <Typography fontSize='sm' mb={0} ml={200} color='interactiveSubtle' display='inline'>
            for developers
          </Typography>
        </Typography>
        <Switch
          label={checked ? 'Collapse data' : 'Expand data'}
          checked={checked}
          onChange={onSwitch}
        />
      </Flex>
      <ObjectRawData key={`${checked}`} obj={object} startExpended={checked} />
    </>
  );
};
